import { unwrap } from '@phoenix/api-client';
import { useAccess, useTenantSession } from '@phoenix/auth';
import { useQuery } from '@tanstack/react-query';

/** قفل نوبت پس از وضعیت (BR-SCH-114). Off هیچ نوبتی را قفل نمی‌کند. */
export function isAppointmentLocked(status: string, policy: string | null | undefined): boolean {
  if (!policy || policy === 'Off') {
    return false;
  }
  if (status === 'Completed') {
    return true;
  }
  if (policy === 'CheckedIn') {
    return status === 'CheckedIn' || status === 'InProgress';
  }
  return policy === 'InProgress' && status === 'InProgress';
}

export function lockPolicyValue(value: unknown): string {
  if (typeof value === 'string' && (value === 'Off' || value === 'CheckedIn' || value === 'InProgress')) {
    return value;
  }
  return 'Off';
}

/** سیاست قفل مستأجر. بدون cfg.settings.view همان Off می‌ماند و سرور همچنان قفل را اعمال می‌کند. */
export function useLockPolicy() {
  const { tenantApi, session } = useTenantSession();
  const access = useAccess();
  const enabled = access.can('cfg.settings.view');
  const query = useQuery({
    queryKey: ['sch', session?.tenantId, 'appointment-lock'],
    queryFn: () =>
      unwrap(tenantApi.GET('/api/v1/configuration/settings/{key}', { params: { path: { key: 'sch.appointment_lock_status' } } })),
    enabled,
    retry: false,
  });
  const policy = lockPolicyValue(query.data?.value);
  const canOverride = access.can('sch.appointment.override');
  return {
    policy,
    canOverride,
    isLocked: (status: string) => isAppointmentLocked(status, policy),
  };
}
